<template>
  <nav class="menu-items sub-menu-items">
    <globe-menu-item
      v-for="item in subMenu.items"
      :key="item.id"
      @action="$emit('select-item', item)"
      :class="{ 'sub-closed': globe.subClosed }"
      :style="{
        backgroundColor: subMenu.colors.background,
        color: subMenu.colors.text
      }"
    >
      <span
        v-html="item.label"
        :style="{
          color: subMenu.colors.text
        }"
      ></span>
    </globe-menu-item>
    <button
      @click="closeSub"
      aria-label="Sluit menu"
      class="close-submenu chevron left"
      :class="{ 'sub-closed': globe.subClosed }"
      :style="{
        'background-color': subMenu.colors.background,
        color: subMenu.colors.text
      }"
    ></button>
  </nav>
</template>

<script>
import GlobeMenuItem from './GlobeMenuItem.vue'
export default {
  components: { GlobeMenuItem },
  props: ['subMenu'],
  data() {
    return {
      closeMenuBackgroundColor: '',
      bgColor: ''
    }
  },
  methods: {
    closeSub() {
      this.rootStore.globeSetSub(false)

      setTimeout(() => {
        this.rootStore.globeSetMain(true)
      }, 300)
    }
  },
  computed: {
    globe() {
      return this.rootStore.globe
    }
  }
}
</script>

<style lang="scss" scoped>
@use '../../../sass/base/_colors.scss' as *;
@use '../../../sass/helpers/_mixins.scss' as *;

$animTime: 0.45s;

.sub-menu-items {
  .sub-closed {
    opacity: 0;
    left: 78px;
    top: 164px;
  }
}

.close-submenu {
  pointer-events: initial;

  @include eclipse(40px);
  background-color: $grey-l;
  box-shadow: rgba(0, 0, 0, 0.23) 0px 8px 24px;
  color: white;
  position: absolute;
  top: 52px;
  transition: top $animTime, left $animTime;
  left: 131px;
}
</style>
